import React from 'react';

function Pagination(props) {
  let {pagination,onNext,onPrev}= props;
  return (
    <div className='flex justify-center mt-4'>
      <button className='text-2xl border-2 border-blue-500 border-r-0 rounded-l-xl p-2' onClick={onPrev}>Previous</button>
      <h3 className='text-2xl border-2 border-blue-500 border-r-0 p-2'>{pagination}</h3>
      <button className='text-2xl border-2 border-blue-500 rounded-r-xl p-2' onClick={onNext}>Next</button>
    </div>
  )
}

export default Pagination;
